import { ErrorMessage, Form, Formik } from "formik"
import { Col } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import Button from "@/components/Button/Button"
import SaveEditButton from "@/components/CrudButtons/SaveEditButton"
import TextInput from "@/components/Inputs/TextInput"
import { MODALS } from "@/constants/modals"
import useFormErr from "@/hooks/useFormErr"
import { useAddTaskMutation } from "@/queries/mutations/enrolledRoundsMutations"
import { studentTaskSchema } from "@/schemas/enrolledSchema"
import { plusIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"

export default function TaskUpload() {
  const { t } = useTranslation()

  const editModalState = useStore((state) => state.editModalState)

  const lecture = useStore(
    (state) => state.modalsStates[MODALS.lecture.uplaodTask]
  )

  const { formErr } = useFormErr<{ task_url: string }>()

  const addtaskMutation = useAddTaskMutation(lecture)

  if (!lecture) return null

  return (
    <Formik
      initialValues={{
        task_url: lecture.my_task_submission?.task_url
          ? lecture.my_task_submission?.task_url
          : "",
      }}
      enableReinitialize
      validationSchema={studentTaskSchema}
      onSubmit={(values) => {
        addtaskMutation.mutate(values, {
          onSuccess: () => editModalState(MODALS.lecture.uplaodTask, undefined),
        })
      }}
    >
      {({ values }) => {
        return (
          <Form>
            <Col md={12} className="mb-4">
              <TextInput
                label={t("taskUpload.data.task_url.label")}
                placeholder={t("taskUpload.data.task_url.placeholder")}
                id="task_url"
                name="task_url"
                error={<ErrorMessage name="task_url" />}
                backError={formErr.task_url}
                as="field"
              />
            </Col>
            <div className="d-flex justify-content-end gap-3 ">
              <Button
                onClick={() =>
                  editModalState(MODALS.lecture.uplaodTask, undefined)
                }
                type="button"
                variant={"normal"}
                className={"justify-content-center "}
                style={{ width: "150px" }}
              >
                {t("buttons.cancel")}
              </Button>
              {lecture?.my_task_submission?.task_url ? (
                <SaveEditButton
                  variant={"secondary"}
                  name={t("buttons.upload")}
                  currentValues={values}
                  initialValues={{
                    task_url: lecture?.my_task_submission?.task_url,
                  }}
                  isLoading={addtaskMutation.isPending}
                />
              ) : (
                <Button
                  type="submit"
                  isLoading={addtaskMutation.isPending}
                  icon={plusIcon}
                  variant={"secondary"}
                  className={"justify-content-center "}
                  style={{ width: "150px" }}
                >
                  {t("buttons.upload")}
                </Button>
              )}
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}
